import { handleMutation } from '../../../legacyCore/Form';
import { DILM_CLIENT_CONTEXT } from '../../../shared/constants';
import { TOPICS } from '../constants';
import type { IScheduleRequest } from '../types';

export default async function markRequestAsScheduled(values, appointmentId, mutations) {
  const { id, token } = values;

  const variables = {
    lmAppointmentId: appointmentId,
    scheduleRequestAttemptId: id,
    token,
  };

  return handleMutation(
    mutations.markScheduleRequestAttemptAsScheduled({ variables, context: DILM_CLIENT_CONTEXT }),
    'markScheduleRequestAttemptAsScheduled'
  );
}

export function getGreetings({ topic, patient, contactPatient }: IScheduleRequest): string {
  if (topic === TOPICS.PATIENT_UNSCHEDULED_HYG_FOLLOWUP) {
    if (patient.pmsId === contactPatient.pmsId) {
      return `Hey ${patient.givenName}, looks like you’re due for your 6 months cleaning.`;
    }
    return `Hey ${contactPatient.givenName}, looks like ${patient.givenName} is due for their 6 months cleaning.`;
  }

  if (patient.pmsId === contactPatient.pmsId) {
    return `Hey ${patient.givenName}, looks like you have dental work that needs to be taken care of.`;
  }
  return `Hey ${contactPatient.givenName}, looks like ${patient.givenName} has dental work that needs to be taken care of.`;
}
